import { render, staticRenderFns } from "./TemplateStatsCalculator.vue?vue&type=template&id=2d35c18a&"
import script from "./TemplateStatsCalculator.vue?vue&type=script&lang=js&"
export * from "./TemplateStatsCalculator.vue?vue&type=script&lang=js&"
import style0 from "./TemplateStatsCalculator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports